import axios from "axios";



export const sendOTP = (data,captchaToken) => {
    return axios.post(`/edrive/api/requestOTP`, data,{
        headers: {
            Captcha: captchaToken
        }
    });
}

export const eDriveLogin = (data)=>{
    return axios.post("/edrive/api/login",data)
}
